export default __webpack_public_path__ + "bml-characteristic3.2846b86.png";